export default "__VITE_ASSET__ZeHxivUN__"